/** Display copy for the question-pack chooser. Prices are confirmed by the server catalog. */

export type QuestionPackId = 'CHAT_5' | 'CHAT_15' | 'CHAT_UNLIMITED_1M';
export const QUESTION_PACK_ORDER: readonly string[] = ['CHAT_5', 'CHAT_15', 'CHAT_UNLIMITED_1M'];
export const DEFAULT_QUESTION_PACK_ID: QuestionPackId = 'CHAT_5';
export const CHOOSER_TITLE = 'Продолжить разбор';

export interface QuestionPackCopy {
  title: string;
  priceMinor: number;
  priceLabel: string;
  description: string;
  detail: string | null;
}

export const QUESTION_PACK_COPY: Record<QuestionPackId, QuestionPackCopy> = Object.freeze({
  CHAT_5: {
    title: '5 вопросов',
    priceMinor: 14900,
    priceLabel: '149 ₽',
    description: 'Чтобы продолжить текущий разбор',
    detail: null,
  },
  CHAT_15: {
    title: '15 вопросов',
    priceMinor: 34900,
    priceLabel: '349 ₽',
    description: 'Если хочешь разобрать несколько тем',
    detail: null,
  },
  CHAT_UNLIMITED_1M: {
    title: 'Безлимит на 30 дней',
    priceMinor: 79000,
    priceLabel: '790 ₽',
    description: 'Для регулярного общения с нумерологом',
    detail: 'Без автопродления',
  },
});

export function chooserSubtitle(hasQuestion: boolean): string {
  if (hasQuestion) return 'Ответ на этот вопрос входит в выбранный пакет.';
  return 'Выбери вариант, чтобы продолжить разговор с нумерологом.';
}

export function purchaseCtaLabel(productId: string, hasQuestion = false): string {
  const pack = QUESTION_PACK_COPY[productId as QuestionPackId];
  return pack ? `${hasQuestion ? 'Получить ответ' : 'Продолжить'} за ${pack.priceLabel}` : 'Продолжить';
}

/** Default selection is UI state. The event fires only on a deliberate change. */
export function shouldTrackPackageSelected(previousId: string, nextId: string): boolean {
  return Boolean(nextId) && previousId !== nextId;
}

export interface CommerceAttribution {
  productId?: string;
  sourceSurface?: 'introductory_reading' | 'daily_forecast' | 'free_question' | 'chat' | 'numbers_explainer';
  angleType?: string;
  questionRank?: 'primary' | 'secondary';
  sourceCampaign?: string;
}

export function commerceAttribution(input: CommerceAttribution & { question?: string }): CommerceAttribution {
  const payload: CommerceAttribution = {};
  if (input.productId) payload.productId = input.productId;
  if (input.sourceSurface) payload.sourceSurface = input.sourceSurface;
  if (input.angleType) payload.angleType = input.angleType;
  if (input.questionRank === 'primary' || input.questionRank === 'secondary') payload.questionRank = input.questionRank;
  if (input.sourceCampaign) payload.sourceCampaign = input.sourceCampaign;
  return payload;
}

export function questionPackDescription(productId: string, hasQuestion: boolean): string {
  if (!hasQuestion) return QUESTION_PACK_COPY[productId as QuestionPackId]?.description ?? '';
  if (productId === 'CHAT_5') return 'Ответ на этот вопрос + ещё 4 вопроса';
  if (productId === 'CHAT_15') return 'Ответ на этот вопрос + ещё 14 вопросов';
  return 'Ответ на этот вопрос + безлимитное общение 30 дней';
}
